module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ud1nU8/tc-custom/9780830858644.jpg?1696025617672",
      "alt": "This image is the cover for the book Burn Up or Splash Down"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Burn Up or Splash Down\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Just like a space shuttle struggles and strains to re-enter the earth's atmosphere, so those returning from living overseas can find themselves confused and in a state of panic at coming home. While people anticipate that going overseas will require major changes in their lifestyles and thinking, few anticipate the difficulties they will face upon return. Intended to aid the re-entry process, this encouraging, and insightful book deals with these important subjects:")]), _vm._v("  adapting to the passport culture identifying areas of potential struggle dealing with the emotional challenges finding a new job, a new place to live, learning the social mores returning is not coming home it is leaving home facilitating a smooth transition for those on the receiving end  "), _c('p', [_vm._v("Expatriates, missionaries, mission executives, mission pastors, mission communities, and supporters interested in easing the re-entry experience will benefit greatly from this book.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marion Knell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Marion Knell has traveled and worked with families overseas, especially in the Arab world. She works as a family crosscultural consultant with business, humanitarian and Christian companies by preparing both adults and children for international assignments and debriefing them upon their return.")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0